import { Globe } from "lucide-react";
import { LANGUAGES } from "@/lib/languages";
import { useLanguage } from "@/context/LanguageContext";
import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";

export const LanguageSelect = ({ compact = true }) => {
  const { lang, change } = useLanguage();

  return (
    <Select value={lang.code} onValueChange={change}>
      <SelectTrigger
        data-testid="language-select-trigger"
        className={`rounded-full border-slate-200 bg-slate-50 font-bold text-xs gap-1.5 ${compact ? "h-9 w-auto px-3" : "h-11 w-full"}`}
        aria-label="Select language"
      >
        <Globe className="w-4 h-4 text-purple-500 shrink-0" />
        <span className="truncate max-w-[90px]">{lang.native}</span>
      </SelectTrigger>
      <SelectContent className="max-h-80">
        {LANGUAGES.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`language-option-${l.code}`}>
            <span className="font-semibold">{l.native}</span>
            <span className="text-slate-400 ml-2 text-xs">{l.name}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelect;
